<div class="row">
  <div class="col-md-6"></div>
  <div class="col-md-6 ml-auto mt-2 px-0 noMarginY">
    <app-login-form (userLoggedIn)="onUserLoggedIn($event)"></app-login-form>
  </div>
</div>
